import { IPaginationModel } from './types'

export const defaultPagination: IPaginationModel = { page: 0, pageSize: 25 }
